module.exports = __webpack_public_path__ + "img/5_12.a902f9ce.png";